module.exports = __webpack_public_path__ + "static/media/disclaimerLogo.f655941c.svg";